// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___fe4f524f7b2da71917e","cls2":"CreateSocialItemModal-cls2___35ae5cf3c44db55b16e CreateSocialItemModal-cls1___fe4f524f7b2da71917e"};